import { render, staticRenderFns } from "./ResponseSLABreachDisplay.vue?vue&type=template&id=1c3b4d00&scoped=true"
import script from "./ResponseSLABreachDisplay.vue?vue&type=script&lang=ts"
export * from "./ResponseSLABreachDisplay.vue?vue&type=script&lang=ts"
import style0 from "./ResponseSLABreachDisplay.vue?vue&type=style&index=0&id=1c3b4d00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b4d00",
  null
  
)

export default component.exports